// extracted by mini-css-extract-plugin
export var grid = "hamburger-menu-module--grid--9f2c5";
export var gridWithRowGap = "hamburger-menu-module--grid--with-row-gap--fe125";
export var hamburgerMenu = "hamburger-menu-module--hamburger-menu--2ab1b";
export var hamburgerMenuDark = "hamburger-menu-module--hamburger-menu--dark--a6bb4";
export var hamburgerMenuOpen = "hamburger-menu-module--hamburger-menu--open--624ad";
export var hamburgerMenu__inner = "hamburger-menu-module--hamburger-menu__inner--6cc19";
export var hamburgerMenu__wrapper = "hamburger-menu-module--hamburger-menu__wrapper--55be0";
export var maxWidthContainer = "hamburger-menu-module--max-width-container--791a2";
export var mt0 = "hamburger-menu-module--mt-0--06092";
export var mt1 = "hamburger-menu-module--mt-1--3f670";
export var mt2 = "hamburger-menu-module--mt-2--e2ed0";
export var mt3 = "hamburger-menu-module--mt-3--41dff";
export var mt4 = "hamburger-menu-module--mt-4--4508e";
export var mt5 = "hamburger-menu-module--mt-5--9602f";
export var mt6 = "hamburger-menu-module--mt-6--ab027";
export var removeVisuallyHidden = "hamburger-menu-module--remove-visually-hidden--efcbd";
export var visuallyHidden = "hamburger-menu-module--visually-hidden--e23d7";
export var widgetBase = "hamburger-menu-module--widget-base--efa2f";